import { useStoreState } from '~/store/hooks';
import { ICurrentClinic } from '~/services/api/clinic/types';
import Features from '~/ui/constants/features';

interface IUseFeature {
  isTreatmentPlansAvailable: boolean;
  isToxicologyAvailable: boolean;
  isBidirectionalAvailable: boolean;
  isDocumentsAvailable: boolean;
  isOpenAiAvailable: boolean;
  isCrisisAvailable: boolean;
  isCrisisAlertsAvailable: boolean;
  isAiAssistAvailable: boolean;
  isInterventionsAvailable: boolean;
  isMedicaidAvailable: boolean;
}

const useFeature = (): IUseFeature => {
  const clinic = useStoreState(state => state.clinic.current || ({} as ICurrentClinic));
  const features = clinic.features || [];

  const isTreatmentPlansAvailable = features.includes(Features.TREATMENT_PLAN);
  const isToxicologyAvailable = features.includes(Features.TOXICOLOGY);
  const isBidirectionalAvailable = features.includes(Features.BIDIRECTIONAL);
  const isDocumentsAvailable = features.includes(Features.DOCUMENTS);
  const isOpenAiAvailable = features.includes(Features.OPEN_AI);
  const isCrisisAvailable = features.includes(Features.CRISIS);
  const isCrisisAlertsAvailable = features.includes(Features.CRISIS_WEB_ALERTS);
  const isAiAssistAvailable = clinic.features?.includes(Features.AI_ASSIST);
  const isInterventionsAvailable = clinic.features?.includes(Features.INTERVENTION);
  const isMedicaidAvailable = features.includes(Features.MEDICAID);

  return {
    isTreatmentPlansAvailable,
    isToxicologyAvailable,
    isBidirectionalAvailable,
    isDocumentsAvailable,
    isOpenAiAvailable,
    isCrisisAvailable,
    isCrisisAlertsAvailable,
    isAiAssistAvailable,
    isInterventionsAvailable,
    isMedicaidAvailable,
  };
};

export default useFeature;
